import {
    Tabs,
    // Carousel,
    DropdownButton, 
    Layout, 
    Menu, 
    Dropdown,
    Form, 
    Input,
    Alert,
    Button,
    Modal,
    Select,
    Space,
    Table,
    Popconfirm,
    Tooltip,
    InputNumber,
    Pagination,
    Image
    // Add other Ant Design components here as needed
  } from 'ant-design-vue';
  
  export default {
    install(app) {
      app.component('a-tabs', Tabs);
      app.component('a-tabs-pane', Tabs.TabPane);
      // app.component('a-carousel', Carousel);
      app.component('a-layout', Layout);
      app.component('a-layout-sider', Layout.Sider);
      app.component('a-layout-content', Layout.Content);
      app.component('a-layout-header', Layout.Header);
      app.component('a-menu', Menu);
      app.component('a-menu-item', Menu.Item);
      app.component('a-sub-menu', Menu.SubMenu);
      app.component('a-dropdown-button', DropdownButton);
      app.component('a-dropdown', Dropdown);
      app.component('a-form', Form);
      app.component('a-form-item', Form.Item);
      app.component('a-input', Input);
      app.component('a-input-group', Input.Group);
      app.component('a-input-password', Input.Password);
      app.component('a-input-search', Input.Search);
      app.component('a-input-number', InputNumber);
      app.component('a-alert', Alert);
      app.component('a-button', Button);
      app.component('a-modal', Modal);
      app.component('a-select', Select);
      app.component('a-select-option', Select.Option);
      app.component('a-space', Space);
      app.component('a-table', Table);
      app.component('a-popconfirm', Popconfirm);
      app.component('a-tooltip', Tooltip);
      app.component('a-pagination', Pagination);
      app.component('a-image', Image);
      app.component('a-image-preview-group', Image.PreviewGroup);
      // Register other Ant Design components globally
    },
  };